<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-mb-dialog tm-info-frame">
    <v-row class="com-mb-dialog-header">
      <span v-if="showInformation" class="com-mb-dialog-title"
        >{{ text.infoTitle }}
      </span>
      <span v-if="showRiverWarnInfo" class="com-mb-dialog-title"
        >{{ text.rwInfoTitle }}
      </span>
      <v-spacer></v-spacer>
      <v-btn small icon color="white" @click="closeInfo">
        <v-icon>highlight_off</v-icon>
      </v-btn>
    </v-row>
    <v-col class="com-mb-dialog-contents tm-info-frame-content">
      <v-col class="com-mb-dialog-frame content-scroll pa-0">
        <map-mb-info v-if="showInformation"></map-mb-info>
        <map-mb-river-warn-info
          v-if="showRiverWarnInfo"
        ></map-mb-river-warn-info>
      </v-col>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 MB用お知らせ・河川予警報一覧フレーム
 * TmInfoFrame.vue
 * @author LIS
 */
import MapMbInfo from "./MapInfo.vue";
import MapMbRiverWarnInfo from "./MapRiverWarnInfo.vue";

export default {
  /** タグ名 */
  name: "map-mb-tm-info-frame",
  components: { MapMbInfo, MapMbRiverWarnInfo },
  data() {
    return {
      /** 文字列リソース */
      text: {
        infoTitle: "お知らせ",
        rwInfoTitle: "発表情報一覧",
      },
    };
  },
  computed: {
    /** お知らせの表示/非表示 */
    showInformation: {
      get() {
        return this.$store.state.map.showInformation;
      },
    },
    /** 河川予警報一覧の表示/非表示 */
    showRiverWarnInfo: {
      get() {
        return this.$store.state.map.showRiverWarnInfo;
      },
    },
  },
  /** メソッド */
  methods: {
    /** お知らせ情報を閉じる */
    closeInfo() {
      this.$store.commit("map/hideInfoRw");
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "../../scss/kwb.scss";
@import "../../scss/_media_query.scss";

@include landscape {
  .tm-info-frame {
    top: 8px;
    left: 60px;
    right: calc(50% + 8px);
    .tm-info-frame-content {
      height: 100%;
      .content-scroll {
        position: static;
        // tm-info-frameのmax-height(=225px) - com-mb-dialog-headerのheight - ダイアログcontentsの余白
        max-height: 225px - 36px - 24px;
      }
    }
  }
}
@include portrait {
  .tm-info-frame {
    width: calc(100% - 16px);
    max-width: 400px;
    right: 4px;
    // 画面全体の高さを算出するため、地図の高さにヘッダーの高さを加算
    // #tm-obs-dialog .normalのheight + bottom
    bottom: calc(((100% + 76px) * 0.5) + 4px);
    .tm-info-frame-content {
      height: 100%;
      .content-scroll {
        position: static;
        // ダイアログのTOP位置をヘッダーの高さ + 8pxにするためのmax-heightの算出
        // 画面全体の高さ - (ヘッダーの高さ + TOP位置) - .tm-info-frameのbottom - (ダイアログヘッダーの高さ + ダイアログcontentsの余白)
        max-height: calc(100vh - (76px + 8px) - (50vh + 4px) - (36px + 24px));
      }
    }
  }
}
</style>
